import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { t } from '../i18n';

export function protectionLabel(protection) {
  if (!protection) return t('streakProtection.noProtection');
  if (protection.type === 'superpass') return t('streakProtection.superpassUsed');
  return t(protection.status === 'reserved' ? 'streakProtection.vacationReserved' : 'streakProtection.vacationUsed');
}

function VacationDateMenu({ date, protection, today, hasStudied, remaining, isBusy, error, onAction, onClose }) {
  const menuRef = useRef(null);
  const future = typeof today === 'string' && date > today;
  const canCancel = future && protection?.type === 'vacation' && protection?.status === 'reserved';
  const canReserve = future && !protection && !hasStudied;

  useLayoutEffect(() => {
    const position = () => {
      const menu = menuRef.current;
      const anchor = menu?.parentElement?.getBoundingClientRect();
      if (!menu || !anchor) return;
      const width = menu.getBoundingClientRect().width;
      const left = Math.max(12, Math.min(anchor.left, window.innerWidth - width - 12));
      menu.style.left = `${left - anchor.left}px`;
      menu.style.right = 'auto';
    };
    position();
    window.addEventListener('resize', position);
    return () => window.removeEventListener('resize', position);
  }, []);

  useEffect(() => {
    const opener = document.activeElement;
    menuRef.current?.focus();
    const outside = event => {
      if (!menuRef.current?.contains(event.target) && !event.target.closest?.('[data-calendar-date]')) onClose();
    };
    document.addEventListener('pointerdown', outside);
    return () => {
      document.removeEventListener('pointerdown', outside);
      if (opener?.isConnected) opener.focus();
    };
  }, [onClose]);

  return (
    <div className="calendar-date-menu" id={`vacation-menu-${date}`} role="dialog" aria-label={t('streakProtection.dateMenu', undefined, { date })} tabIndex={-1} ref={menuRef}
      onKeyDown={event => { if (event.key === 'Escape' && !isBusy) { event.stopPropagation(); onClose(); } }}>
      <div className="calendar-date-menu-heading"><strong>{date}</strong><button type="button" onClick={onClose} disabled={isBusy} aria-label={t('streakProtection.close')}><X size={16} aria-hidden="true" /></button></div>
      <p>{hasStudied ? t('streakProtection.studyDay') : protectionLabel(protection)}</p>
      {(canReserve || canCancel) ? (
        <>
          <p className="calendar-date-menu-hint">{t(canReserve && remaining <= 0 ? 'streakProtection.quotaReached' : 'streakProtection.futureHint')}</p>
          <button type="button" className="calendar-vacation-action" disabled={isBusy || (canReserve && remaining <= 0)} aria-busy={isBusy} onClick={() => onAction(canCancel ? 'cancel' : 'reserve')}>
            {t(isBusy ? 'streakProtection.saving' : canCancel ? 'streakProtection.cancel' : 'streakProtection.reserve')}
          </button>
        </>
      ) : <p className="calendar-date-menu-hint">{t('streakProtection.readOnly')}</p>}
      {error && <p className="calendar-vacation-error" role="alert">{error}</p>}
    </div>
  );
}

export default VacationDateMenu;
